// removed by extract-text-webpack-plugin
module.exports = {"block":"O_5FSm2hV9TcD089ZRi9C","column":"_3npboBTUscxEWXvB_yYoyN","info":"_3T3PDIhZ9oLkxQ5cylGwUW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectInfoBlock/ProjectInfoBlock.module.scss
// module id = 798
// module chunks = 0